import type { FaireProductEntity } from "../../entity_types/product";

export const p_naq6q2ygdd: FaireProductEntity = {
  token: "p_naq6q2ygdd",
  type: "product",
  name: "Mahjong Rack Storage Bag Mahjong Gift Leather | 4 Colors",
  brandToken: "b_5sfnb3y1",
  brandName: "Aspen Lane",
  imageUrl:
    "https://cdn.faire.com/fastly/a2fa6a7bd80dfc61659b4c33cc6fa93c9c75f4e9938936f202cd6b0bcad5c9f0.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d826a534f8a308d8cd4478882545feef3a071b4e34b3d58ccfe4c96b57d345d0.png",
    "https://cdn.faire.com/fastly/0c5e53bd1c8a9ef953e6eb63f5d038d7845f29c23dd132c18d9118ecf4f15cf0.png",
    "https://cdn.faire.com/fastly/64e3e611ef456fa2cdc813dbb91f7e7e062d8dbc45a815fef814b08c9ca198e3.png",
    "https://cdn.faire.com/fastly/fd11ce23ff4d05864352f3958625e180d28cc24859e2885bb419fe27df3bf68e.png",
    "https://cdn.faire.com/fastly/678081d6636459997ea5674cf2cbf30f7f662916b61e2207024ad482803afaa0.png",
    "https://cdn.faire.com/fastly/bb4f0ed239a04ce590ef771006f15e852d0039f30f1afec56025b3da5783f293.png",
    "https://cdn.faire.com/fastly/682d3a7a8cb00305e03f75ec3c47da6f60404518eb9eea5492f723fc4adfb2b9.png",
    "https://cdn.faire.com/fastly/074600b8f8f8bc7afdacb88435296e0253e87dfe19937f86401acd8a68991173.png",
  ],
  priceDollars: 15,
  description:
    'Mahjong rack & pusher bag (storage): meet your new best seller at an amazing price point with unmatched quality. *PEARL IS SOLD OUT. We sure do love a variety colorful colorblock combination-Rack and Roll is screen printed on the front! Perfect for mahjong tile storage, mahjong gifts, mahjong tile storage, and preppy gift sections.\n\nMahjong Tile Storage Bag Info\n:: Saffiano Leatherette Vegan: 22" x 8" flat zip-fits our coordinating oversized tote bag and mahjong tile pouch.\n:: Perfect to hold mahjong card, jewelry, and other personal items\n:: Custom colorful coordinating handles\n:: Snap closure, inside pocket and satin lining.\n\nSee coordinating mahjong oversized storage and mahjong tile storage pouch.',
  tags: [],
  msrpDollars: 30,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:48:29.044Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
